module.exports = __webpack_public_path__ + "static/img/jovyn-chamb-iWMfiInivp4.950ef7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911261/jovyn-chamb-iWMfiInivp4.jpg
// module id = NGlj
// module chunks = 1